import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
import ServiceAPI from '@/httpService/serviceApi';
//获取登录成功后跳转地址和主动退出跳转的地址
export const getLoginAndOutGoPath = () => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/third/config/v1/login-logout');
};
//获取专属门户配置,在点击登录时判断跳转到哪
export const getSpecialPortal = (portalId) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/user/third/config/v1/portal/' + portalId);
};
//oauth token登录
export const oauthTokenLogin = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/third/v1/oauth/token', data);
};
//oauth登录
export const oauthCodeLogin = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/third/v1/oauth/code', data);
};
export const getTenantList = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/tenant/list');
};

//验证码登录
export const smsLogin = (data, type) => {
    if (type === 'competition') {
        return hMacAjax.post(baseURL + '/grt-user-service/user/v1/competition/login/sms', data);
    }
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/custom/login/sms', data);
};

//多因子登录
export const codeVerifyLogin = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/login/sms', data);
};

//账号密码登录
export const accountLogin = (data, type) => {
    if (type === 'competition') {
        return hMacAjax.post(baseURL + '/grt-user-service/user/v2/competition/login/account', data);
    }
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/custom/login/account', data);
};

//发送验证码
export const getSms = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/sms_voice', data);
};

//忘记密码第一步
export const verifyFirst = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/forget/pwd/verify', data);
};

//忘记密码第二步
export const verifySecond = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/forget/pwd', data);
};

//修改手机号第一步
export const moblieVerifyFirst = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/modify/mobile/verify', data);
};

//修改手机号第二步
export const moblieVerifySecond = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/modify/mobile', data);
};

//修改密码第一步 - 手机号验证
export const mobileVerify = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/modify/pwd/mobile_verify', data);
};

//修改密码第一步 - 密码验证
export const pwdVerify = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/modify/pwd/pwd_verify', data);
};
//修改密码第二步
export const pwdModify = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/modify/pwd', data);
};

//用户信息
export const getUserInfo = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/');
};

//退出登录
export const outLogin = () => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/logout');
};

//管理员信息
export const getAdminUserInfo = () => {
    return hMacAjax.get(baseURL + '/apaas-system-service/identity/v1/user/info');
};

//管理员信息
export const getTenantInfo = () => {
    return hMacAjax.get(baseURL + '/apaas-system-service/sys/v1/tenant/info');
};
//
export const tenantSort = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/tenant/sort', data);
};

//大赛需求新增接口 start

//租户信息
export const tenantInfo = () => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/tenant/v1');
};

//获取学员完善信息
export const improveInfoDetail = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/student/v1/student/improve/detail', data);
};

//学员完善信息提交
export const submitImproveInfo = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/student/v1/student/improve', data);
};
//大赛需求新增接口 end

//获取第三方配置接口
export const thirdConfig = () => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/third-dock/v1/config');
};
//检测登录状态
export const checkToken = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/token/check', {});
};

//获取租户是否开启自主注册配置
export const fetchRegisteredStatus = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/open/user/v1/student/self/registered/status', {});
};

//获取承培学员完善信息
export const improveInfoDetailUndertake = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/student/v1/undertake/student/improve/detail', data);
};

//学员承培完善信息提交
export const submitImproveInfoUndertake = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/student/v1/undertake/student/improve', data);
};

//学员承培通过业务id查询业务选择的orgid
export const submitImproveInfoOrgids = (id) => {
    return hMacAjax.get(baseURL + `/grt-user-center-service/open/business/${id}/org-ids`);
};

//学员承培通过组织ID查询承接方学生完善信息
export const submitImproveInfoByOrg = (config_id) => {
    return hMacAjax.get(baseURL + `/grt-user-center-service/open/student/v1/undertake/student/improve/detail/by-configId/${config_id}`);
};

//根据类型查询租户配置-公开
export const systemConfigGtByType = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/user/systemConfig/v1/getByType', data);
};

//获取独立域名浏览器标签头配置
export const getLoginTabConfigReq = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/systemConfig/v1', params);
};

//获取临时密钥
export const getAESKey = () => {
    return hMacAjax.get(ServiceAPI.userAPI + '/open/user/v1/temp-aes-key/generate');
};

//完善信息后快速登录
export const quickLogin = (data) => {
    return hMacAjax.post(ServiceAPI.userAPI + '/open/user/v2/custom/quick/login', data);
};
// 查询登录页配置
export const getLoginCustomConfigApi = () => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/decoration/custom-login');
};

// 登录页自定义配置
export async function handleGetCustomLogin() {
    return hMacAjax.get(ServiceAPI.systemAPI + '/decoration/homepage/v1/custom-login');
}